module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<h4>'+
((__t=( title ))==null?'':__t)+
'</h4><div class="pl60" data-container="unit-test-definitions"></div>';
}
return __p;
};
